import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-lg-500px bg-white shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3" }, "Login to Neoris")
], -1)
const _hoisted_3 = { class: "fv-row mb-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-dark" }, "Email", -1)
const _hoisted_5 = { class: "fv-plugins-message-container" }
const _hoisted_6 = { class: "fv-help-block" }
const _hoisted_7 = { class: "fv-row mb-10" }
const _hoisted_8 = { class: "d-flex flex-stack mb-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 mb-0" }, "Password", -1)
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_sign_in_submit",
  class: "btn btn-lg btn-primary w-100 mb-5"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Login ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Login... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, "Register", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      class: "form w-100",
      id: "kt_login_signin_form",
      onSubmit: _ctx.onSubmitLogin,
      "validation-schema": _ctx.login
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_Field, {
            class: "form-control form-control-lg form-control-solid",
            type: "text",
            name: "email",
            autocomplete: "off",
            placeholder: "john@example.org"
          }),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_ErrorMessage, { name: "email" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_router_link, {
              to: "/password-reset",
              class: "link-info fs-6 fw-bolder"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Forgotten password? ")
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_Field, {
            class: "form-control form-control-lg form-control-solid",
            type: "password",
            name: "password",
            autocomplete: "off",
            placeholder: "****"
          }),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_ErrorMessage, { name: "password" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", _hoisted_13, _hoisted_16, 512),
          _createVNode(_component_router_link, {
            to: "/sign-up",
            class: "btn btn-lg btn-secondary w-100 mb-5"
          }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}